import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocationState } from "../../types";

const initialState: LocationState = {
  city: null,
  state: null,
  country: null,
  lng: null,
  lat: null,
  fetched: false,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setCity: (state, action: PayloadAction<string>) => {
      state.city = action.payload;
    },
    setState: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    setCountry: (state, action: PayloadAction<string>) => {
      state.country = action.payload;
    },
    setGeoCords: (
      state,
      action: PayloadAction<{ lng: number; lat: number }>,
    ) => {
      state.lng = action.payload.lng;
      state.lat = action.payload.lat;
    },
    setFetchedGeoLoc: (state) => {
      state.fetched = true;
    },
  },
});

export const { setCity, setState, setCountry, setGeoCords, setFetchedGeoLoc } =
  locationSlice.actions;
export default locationSlice.reducer;
